import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 md:px-12 py-16 sm:py-24">
        <h1 className="text-5xl sm:text-6xl tracking-tight leading-none font-black mb-8" data-testid="about-title">
          About Us
        </h1>
        <div className="prose prose-lg max-w-none">
          <p className="text-base sm:text-lg leading-relaxed mb-6">
            Welcome to <strong>The Pune Perspective</strong>, your trusted source for automotive industry insights, 
            local Pune news, and in-depth reviews that matter to you.
          </p>
          <p className="text-base sm:text-lg leading-relaxed mb-6">
            Founded with a passion for automotive excellence and a deep connection to Pune's vibrant community, 
            we bring you comprehensive coverage of car launches, market trends, EV innovations, and local events 
            that shape our city.
          </p>
          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Our Mission
          </h2>
          <p className="text-base sm:text-lg leading-relaxed mb-6">
            We strive to deliver accurate, timely, and engaging content that helps our readers stay informed 
            about the automotive industry and local developments. Whether you're a car enthusiast, industry 
            professional, or Pune resident, we're here to provide valuable perspectives.
          </p>
          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            What We Cover
          </h2>
          <ul className="list-disc pl-6 space-y-2 text-base sm:text-lg leading-relaxed mb-6">
            <li><strong>Automotive News:</strong> Latest car launches, market analysis, and sales trends</li>
            <li><strong>EV & Future Mobility:</strong> Electric vehicles and sustainable transportation</li>
            <li><strong>Reviews:</strong> Honest test drives and vehicle evaluations</li>
            <li><strong>Pune Local:</strong> City events, auto expos, and community stories</li>
            <li><strong>Industry Insights:</strong> Expert analysis and opinion pieces</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
